/**
 * @desc 分页查询加盟信息列表
 */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {}

export function request(data: defs.PageRequest<defs.JoinThePagingParametersList>): Promise<BaseResponse<defs.PageBean<Array<defs.TheDriverToJoinAudit>>>> {
  return fetch({
    url: config.API_HOST + '/base/selfDriverAudit/findJointPageList',
    data: data,
    method: 'POST',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
